


// import React from "react";
// import InfoContent from "./InfoContent";
// import ImageSection from "./ImageSection";
// import FAQBox from "./FAQBox";
// import BadgeSection from "./BadgeSection";
// // import LeftSidebar from "./Sidebars/LeftSidebar";

// const AboutSection = () => {
//   return (
//     // <section className="bg-gray-50 py-12 px-4">
//     // <section className="bg-gray-50 pt-0 pb-12 px-4">
//     <section className="bg-gray-50 pt-8 pb-12 px-4">


//       <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8  lg:text-left">
//         {/* Sol taraf: içerikler + görsel */}
//         <div className="lg:col-span-2 flex flex-col items-center space-y-10">
            
//           <InfoContent />
//           <ImageSection />
        
//         </div>

//         {/* Sağ taraf: SSS + Rozetler */}
//         <aside className="flex flex-col items-center space-y-6">
//           <FAQBox />
//           <BadgeSection />
//         </aside>
//       </div>
//     </section>
//   );
// };

// export default AboutSection;
import React from "react";
import InfoContent from "./InfoContent";
import ImageSection from "./ImageSection";
import FAQBox from "./FAQBox";
import BadgeSection from "./BadgeSection";

const AboutSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-gray-50 to-emerald-50/40 pt-12 pb-16 px-4">
      {/* Arka plan dekor */}
      <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-emerald-200/30 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-24 h-80 w-80 rounded-full bg-yellow-200/30 blur-3xl" />

      <div className="relative max-w-screen-xl mx-auto">
        {/* Üst başlık */}
        <div className="mx-auto mb-10 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full bg-emerald-100 px-4 py-2 text-sm font-semibold text-emerald-700">
            Profesyonel Halı Yıkama Hizmeti
          </span>

          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-gray-900">
            Hijyenik, Güvenilir ve Özenli Temizlik
          </h2>

          <p className="mt-5 text-base md:text-lg leading-8 text-gray-600">
            Halılarınızı modern ekipmanlar, güçlü leke çıkarma yöntemleri ve
            hijyen odaklı temizlik süreciyle ilk günkü ferahlığına kavuşturuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:items-start">
          {/* Sol içerik alanı */}
          <div className="lg:col-span-2">
            <div className="rounded-[2rem] border border-white/70 bg-white/80 backdrop-blur-xl shadow-[0_20px_60px_rgba(15,23,42,0.08)] p-5 md:p-8">
              <div className="flex flex-col items-center lg:items-stretch space-y-10">
                <InfoContent />
                <ImageSection />
              </div>
            </div>
          </div>

          {/* Sağ taraf */}
          <aside className="lg:sticky lg:top-28 flex flex-col gap-6">
            <div className="rounded-[2rem] border border-white/70 bg-white/90 backdrop-blur-xl shadow-[0_20px_60px_rgba(15,23,42,0.08)] p-5 md:p-6">
              <FAQBox />
            </div>

            <div className="rounded-[2rem] border border-white/70 bg-white/90 backdrop-blur-xl shadow-[0_20px_60px_rgba(15,23,42,0.08)] p-5 md:p-6">
              <BadgeSection />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;